<template>
  <div class="image-options-setting-dialog">
    <div v-show="activeType == 1" class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')"
          title="分隔符"
          name="4"
        >
          <div
            class="content-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')"
          >
            <div class="verticallyCenter mb16">
              <cx-select :value.sync="separatorType" :selectOptions="separatorTypeSelectOptions" title="类型" />
            </div>
            <div v-if="separatorType === 'icon'">
              <img-icon-upload
                class="mb16"
                :imgSrc.sync="iconSrc"
                :iconType.sync="iconType"
                :iconColor.sync="iconColor"
              />
              <div class="verticallyCenter mb16" v-if="iconType === 'icon'">
                <span class="mr16 fs14">颜色</span>
                <color-picker-theme-color
                  class="flex1"
                  :isThemeColor.sync="iconColorIsThemeColor"
                  :color.sync="iconColor"
                >
                </color-picker-theme-color>
              </div>
              <slider-and-input class="mb16" :value.sync="iconWidth" title="大小" :sliderMax="sliderMax" suffix="px" />
            </div>
            <slider-and-input :value.sync="iconMargin" title="间距" :sliderMax="sliderMax" suffix="px" />
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')" title="外观" name="2">
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
          >
            <div class="content">
              <div class="content-item mb16">
                <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
              </div>
              <cx-background :background.sync="background" imgType="10" class="mt16" />
              <div class="content-item mt16">
                <div class="checkbox_colorPicker_container">
                  <span>阴影</span>
                  <span
                    v-show="borderShadowChecked"
                    class="icon-portal-plus theme-color right-icon"
                    @click="addBoxshadow"
                  ></span>
                </div>
                <box-shadow
                  v-show="borderShadowChecked"
                  :boxShadowH.sync="boxShadowH"
                  :boxShadowV.sync="boxShadowV"
                  :boxShadowBlur.sync="boxShadowBlur"
                  :boxShadowSpread.sync="boxShadowSpread"
                  :boxShadowColor.sync="boxShadowColor"
                ></box-shadow>
              </div>
              <div class="content-item mt16">
                <public-style :options="options" :ids="ids"></public-style>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
          title="文字"
          name="3"
        >
          <div
            class="setting-item clearFloat"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')"
          >
            <text-setting-complex-update
              class="mb8"
              :fontFamily.sync="fontFamily"
              :fontSize.sync="fontSize"
              :fontWeight.sync="fontWeight"
              :fontStyle.sync="fontStyle"
              :textDecoration.sync="textDecoration"
              :lineHeight.sync="lineHeight"
              :letterSpacing.sync="letterSpacing"
              :activeArrangement.sync="activeArrangement"
              :writingMode.sync="writingMode"
              :textAlign.sync="textAlign"
              :showTextAlignSetting="false"
              :activeArrangementOrder.sync="activeArrangementOrder"
              :lineHeightType.sync="lineHeightType"
              :letterSpacingType.sync="letterSpacingType"
              :isThemeColor.sync="textIsThemeColor" 
              :colorArr.sync="color"
              :showOverflowSetting="true"
              :overflowTypes="['字数', '无']"
              :contentHasLimit.sync="contentHasLimit"
              :contentHasLimitRadio="'字数'"
              :textLimitWords.sync="textLimitWords"
              :hideHighLevelSetting="true"
              :showColorSet="false"
              :options="options"
            />
            <div class="verticallyCenter">
              <span class="fs14 mr16">颜色</span>
              <color-picker-theme-color
                class="flex1"
                :isThemeColor.sync="textIsThemeColor"
                :color.sync="color"
              >
              </color-picker-theme-color>
            </div>
            <div v-show="contentHasLimit" class="content-item mt8">
              <el-checkbox v-model="textOverflowEllipsis">溢出内容以省略号形式显示</el-checkbox>
            </div>
          </div>
          <div></div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')" title="边框" name="5">
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')"
          >
            <div class="content">
              <div class="content-item mb16">
                <border-radius
                  :borderTypeFlag.sync="borderTypeFlag"
                  :borderRadius.sync="borderRadius"
                  :borderTopLeftRadius.sync="borderTopLeftRadius"
                  :borderTopRightRadius.sync="borderTopRightRadius"
                  :borderBottomRightRadius.sync="borderBottomRightRadius"
                  :borderBottomLeftRadius.sync="borderBottomLeftRadius"
                />
              </div>
              <div class="content-item mb24 clearFloat">
                <div class="checkbox_colorPicker_container mb16">
                  <!--                  <el-checkbox v-model="borderChecked" @change="checkboxHandle(2, '')">边框</el-checkbox>-->
                  <span class="fs14">边框</span>
                </div>
                <div v-show="borderChecked" class="select-input-container verticallyTop">
                  <cx-border
                    :borderWidth.sync="borderWidth"
                    :borderStyle.sync="borderStyle"
                    :borderColor.sync="borderColor"
                    :borderIsThemeColor.sync="borderIsThemeColor"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')" title="边距" name="6">
          <cx-padding
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '6')"
            :paddingTypeFlag.sync="textPaddingTypeFlag"
            :padding.sync="padding"
            :paddingTop.sync="paddingTop"
            :paddingRight.sync="paddingRight"
            :paddingBottom.sync="paddingBottom"
            :paddingLeft.sync="paddingLeft"
          />
        </el-collapse-item>
      </el-collapse>
    </div>
    <div v-show="activeType == 2" class="content-group-active">
      <el-collapse v-model="activeNames">
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
          title="文字样式"
          name="3"
        >
          <div
            class="setting-item clearFloat"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')"
          >
            <text-setting-complex-update
              class="mb8"
              :fontFamily.sync="activeFontFamily"
              :fontSize.sync="activeFontSize"
              :fontWeight.sync="activeFontWeight"
              :fontStyle.sync="activeFontStyle"
              :textDecoration.sync="activeTextDecoration"
              :lineHeight.sync="activeLineHeight"
              :letterSpacing.sync="activeLetterSpacing"
              :activeArrangement.sync="activeActiveArrangement"
              :writingMode.sync="activeWritingMode"
              :textAlign.sync="activeTextAlign"
              :showTextAlignSetting="false"
              :activeArrangementOrder.sync="activeActiveArrangementOrder"
              :lineHeightType.sync="activeLineHeightType"
              :letterSpacingType.sync="activeLetterSpacingType"
              :showColorSet="false"
              :options="options"
            />
            <div class="verticallyCenter">
              <span class="fs14 mr16">颜色</span>
              <color-picker-theme-color
                class="flex1"
                :isThemeColor.sync="activeTextIsThemeColor"
                :color.sync="activeColor"
              >
              </color-picker-theme-color>
            </div>
          </div>
          <div></div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div v-show="activeType == 3 && !hoverIsSameActive" class="content-group-hover">
      <el-collapse v-model="activeNames">
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
          title="文字样式"
          name="3"
        >
          <div
            class="setting-item clearFloat"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')"
          >
            <text-setting-complex-update
              class="mb8"
              :fontFamily.sync="hoverFontFamily"
              :fontSize.sync="hoverFontSize"
              :fontWeight.sync="hoverFontWeight"
              :fontStyle.sync="hoverFontStyle"
              :textDecoration.sync="hoverTextDecoration"
              :lineHeight.sync="hoverLineHeight"
              :letterSpacing.sync="hoverLetterSpacing"
              :activeArrangement.sync="hoverActiveArrangement"
              :writingMode.sync="hoverWritingMode"
              :textAlign.sync="hoverTextAlign"
              :showTextAlignSetting="false"
              :activeArrangementOrder.sync="hoverActiveArrangementOrder"
              :lineHeightType.sync="hoverLineHeightType"
              :letterSpacingType.sync="hoverLetterSpacingType"
              :showColorSet="false"
              :options="options"
            />
            <div class="verticallyCenter">
              <span class="fs14 mr16">颜色</span>
              <color-picker-theme-color
                class="flex1"
                :isThemeColor.sync="hoverTextIsThemeColor"
                :color.sync="hoverColor"
              >
              </color-picker-theme-color>
            </div>
          </div>
          <div></div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import TextSettingComplex from "modules/components/textSettingComplex"
import { withMethodsHistoryCombine } from "utils/revork"
import publicStyle from "publicSetting/publicStyle.vue"
export default withMethodsHistoryCombine({
  name: "button-options-setting",
  components: { controlWidthAndSizeAndZindex, TextSettingComplex, publicStyle },
  props: { options: Object, activeType: String },
  data() {
    return {
      defaultImage: require("assets/images/image_placeholder.png"),
      this1: this,
      // collapseActiveNames: ["1", "2", "7"],
      collapseActiveNames: ["1", "2", "3", "4", "5", "6", "7"],
      activeNames: ["1", "2", "3", "4", "5", "6", "7"],
      allCollapseNames: ["1", "2", "3", "4", "5", "6", "7"],
      // allCollapseNames: ["3", "4", "5", "6"],
      shapeChecked: true,
      hoverShapeChecked: true,
      borderChecked: true,
      hoverBorderChecked: true,
      borderRadiusChecked: true,
      hoverBorderRadiusChecked: true,
      borderShadowChecked: true,
      hoverBorderShadowChecked: true,
      rotateChecked: true,
      hoverRotateChecked: true,
      sliderMax: 360,
      hoverBorderTypeFlag: 1,
      fontStyleList: [
        {
          _class: "icon-portal-text-bold1",
          isActive: false
        },
        {
          _class: "icon-portal-text-italic1",
          isActive: false
        },
        {
          _class: "icon-portal-text-underline1",
          isActive: false
        }
      ],
      fontFamilyList: [
        {
          value: "默认",
          label: "default"
        },
        {
          value: "默认字体",
          label: "PingFang SC"
        }
      ],
      borderStyleList: [
        {
          value: "solid",
          label: "实线",
          title: "",
          src: require("../../../assets/images/solid-1.png")
        },
        {
          value: "dashed",
          label: "虚线",
          title: "",
          src: require("../../../assets/images/dashed-1.png")
        },
        {
          value: "dotted",
          label: "点线",
          title: "",
          src: require("../../../assets/images/dotted-1.png")
        }
      ],
      bgTypes: [
        {
          name: "自定义"
        },
        {
          name: "图片"
        }
      ],
      arrangementList: [
        {
          label: "左对齐",
          className: "icon-portal-text-leftt1",
          value: "left"
        },
        {
          label: "右对齐",
          className: "icon-portal-text-right1",
          value: "right"
        },
        {
          label: "居中对齐",
          className: "icon-portal-text-center1",
          value: "center"
        },
        {
          label: "两端对齐",
          className: "icon-portal-text-both1",
          value: "justify"
        }
      ],
      separatorTypeSelectOptions: [
        {
          value: "str",
          label: "斜杠分隔符“/”"
        },
        {
          value: "icon",
          label: "图标分隔符"
        }
      ]
    }
  },
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    activeRect() {
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    width: {
      get() {
        return this.options.width || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "width", false)
      }
    },
    height: {
      get() {
        return this.options.height || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "height", false)
      }
    },
    left: {
      get() {
        return this.options.left || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "left", false)
      }
    },
    top: {
      get() {
        return this.options.top || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "top", false)
      }
    },
    fontSize: {
      get() {
        return this.options.fontSize || 12
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontSize", false)
      }
    },
    fontStyle: {
      get() {
        return this.options.fontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontStyle", false)
      }
    },
    fontWeight: {
      get() {
        return this.options.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontWeight", false)
      }
    },
    lineHeight: {
      get() {
        return this.options.lineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeight", false)
      }
    },
    textDecoration: {
      get() {
        return this.options.textDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textDecoration", false)
      }
    },
    color: {
      get() {
        return this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "color", false)
      }
    },
    textIsThemeColor: {
      get() {
        return this.options.textIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIsThemeColor", false)
      }
    },
    contentHasLimit: {
      get() {
        return this.options.contentHasLimit
      },
      set(newVal) {
        if (newVal && !this.options.textLimitWords) {
          this.$changeOptionsEV(4, "textLimitWords", false)
        }
        this.$changeOptionsEV(newVal, "contentHasLimit", false)
      }
    },
    textLimitWords: {
      get() {
        return this.options.textLimitWords
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textLimitWords", false)
      }
    },
    textOverflowEllipsis: {
      get() {
        return this.options.textOverflowEllipsis
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textOverflowEllipsis", false)
      }
    },
    bgColorIsThemeColor: {
      get() {
        return this.options.bgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColorIsThemeColor", false)
      }
    },
    bgColor: {
      get() {
        return this.options.bgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColor", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "background", false)
      }
    },
    fontFamily: {
      get() {
        return this.options.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontFamily", false)
      }
    },
    shapeType: {
      get() {
        return this.options.shapeType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "shapeType", false)
      }
    },
    borderTopLeftRadius: {
      get() {
        return Number(this.options.borderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return Number(this.options.borderTopRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return Number(this.options.borderBottomRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return Number(this.options.borderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderRadius: {
      get() {
        return Number(this.options.borderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        // return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.borderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderWidth", "borderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.options.borderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.options.boxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.boxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.boxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.boxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.boxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    rotate: {
      get() {
        return parseInt(this.options.rotate)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "rotate", false)
      }
    },
    imgSrc: {
      get() {
        return this.options.imgSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "imgSrc", false)
      }
    },
    clipSize: {
      get() {
        return this.options.clipSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "clipSize", false)
      }
    },
    bgType: {
      get() {
        return this.options.bgType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgType", false)
      }
    },
    repeatType: {
      get() {
        return this.options.repeatType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "repeatType", false)
      }
    },
    alignType: {
      get() {
        return this.options.alignType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "alignType", false)
      }
    },
    activeArrangement() {
      return this.options.textAlign
    },
    opacity: {
      get() {
        return this.options.opacity * 100
      },
      set(newVal) {
        // 以前数据最大100，现在1，脏数据处理不记录
        if (this.options.opacity === 100) {
          this.$changeOptionsEV(newVal / 100, "opacity", false, false, false, true)
        } else {
          this.$changeOptionsEV(newVal / 100, "opacity", false)
        }
      }
    },
    textAlign: {
      get() {
        return this.options.textAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textAlign", false)
      }
    },
    activeArrangementOrder: {
      get() {
        return {
          label: "竖排文字",
          _class: "icon-portal-text-down1",
          isActive: this.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.writingMode = val
      }
    },
    writingMode: {
      get() {
        return this.options.writingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "writingMode", false)
      }
    },
    letterSpacing: {
      get() {
        return this.options.letterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacing", false)
      }
    },
    // 边距
    textPaddingTypeFlag: {
      get() {
        let defaultType = 2
        return this.checkAndSetPrimaryVal(this.options, "textPaddingTypeFlag", "textPaddingTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textPaddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "padding", "padding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingTop", "paddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingRight", "paddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingLeft", "paddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingBottom", "paddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    hoverFontSize: {
      get() {
        let data = this.options.hasOwnProperty("hoverFontSize") ? this.options.hoverFontSize : this.options.fontSize
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontSize", false)
      }
    },
    hoverFontStyle: {
      get() {
        let data = this.options.hasOwnProperty("hoverFontStyle") ? this.options.hoverFontStyle : this.options.fontStyle
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontStyle", false)
      }
    },
    hoverFontWeight: {
      get() {
        let data = this.options.hasOwnProperty("hoverFontWeight")
          ? this.options.hoverFontWeight
          : this.options.fontWeight
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontWeight", false)
      }
    },
    hoverTextDecoration: {
      get() {
        let data = this.options.hasOwnProperty("hoverTextDecoration")
          ? this.options.hoverTextDecoration
          : this.options.textDecoration
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextDecoration", false)
      }
    },
    hoverColor: {
      get() {
        let data = this.options.hasOwnProperty("hoverColor") ? this.options.hoverColor : this.options.color
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverColor", false)
      }
    },
    hoverLineHeight: {
      get() {
        let data = this.options.hasOwnProperty("hoverLineHeight")
          ? this.options.hoverLineHeight
          : this.options.lineHeight
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverLineHeight", false)
      }
    },
    hoverLetterSpacing: {
      get() {
        let data = this.options.hasOwnProperty("hoverLetterSpacing")
          ? this.options.hoverLetterSpacing
          : this.options.letterSpacing
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverLetterSpacing", false)
      }
    },
    hoverTextAlign: {
      get() {
        let data = this.options.hasOwnProperty("hoverTextAlign") ? this.options.hoverTextAlign : this.options.textAlign
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextAlign", false)
      }
    },
    hoverActiveArrangement() {
      return this.options.hoverTextAlign
    },
    hoverActiveArrangementOrder: {
      get() {
        return {
          label: "竖排文字",
          _class: "icon-portal-text-down1",
          isActive: this.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.writingMode = val
      }
    },
    hoverWritingMode: {
      get() {
        let data = this.options.hasOwnProperty("hoverWritingMode")
          ? this.options.hoverWritingMode
          : this.options.writingMode
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverWritingMode", false)
      }
    },
    hoverTextIsThemeColor: {
      get() {
        let data = this.options.hasOwnProperty("hoverTextIsThemeColor")
          ? this.options.hoverTextIsThemeColor
          : this.options.isThemeColor
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextIsThemeColor", false)
      }
    },
    hoverFontFamily: {
      get() {
        let data = this.options.hasOwnProperty("hoverFontFamily")
          ? this.options.hoverFontFamily
          : this.options.fontFamily
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontFamily", false)
      }
    },
    activeFontSize: {
      get() {
        let data = this.options.hasOwnProperty("activeFontSize") ? this.options.activeFontSize : this.options.fontSize
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontSize", false)
      }
    },
    activeFontStyle: {
      get() {
        let data = this.options.hasOwnProperty("activeFontStyle")
          ? this.options.activeFontStyle
          : this.options.fontStyle
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontStyle", false)
      }
    },
    activeFontWeight: {
      get() {
        let data = this.options.hasOwnProperty("activeFontWeight")
          ? this.options.activeFontWeight
          : this.options.fontWeight
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontWeight", false)
      }
    },
    activeTextDecoration: {
      get() {
        let data = this.options.hasOwnProperty("activeTextDecoration")
          ? this.options.activeTextDecoration
          : this.options.textDecoration
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTextDecoration", false)
      }
    },
    activeColor: {
      get() {
        let data = this.options.hasOwnProperty("activeColor") ? this.options.activeColor : this.options.color
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeColor", false)
      }
    },
    activeLineHeight: {
      get() {
        let data = this.options.hasOwnProperty("activeLineHeight")
          ? this.options.activeLineHeight
          : this.options.lineHeight
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeLineHeight", false)
      }
    },
    activeLetterSpacing: {
      get() {
        let data = this.options.hasOwnProperty("activeLetterSpacing")
          ? this.options.activeLetterSpacing
          : this.options.letterSpacing
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeLetterSpacing", false)
      }
    },
    activeTextAlign: {
      get() {
        let data = this.options.hasOwnProperty("activeTextAlign")
          ? this.options.activeTextAlign
          : this.options.textAlign
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTextAlign", false)
      }
    },
    activeActiveArrangement() {
      return this.options.activeTextAlign
    },
    activeActiveArrangementOrder: {
      get() {
        return {
          label: "竖排文字",
          _class: "icon-portal-text-down1",
          isActive: this.activeWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.activeWritingMode = val
      }
    },
    activeWritingMode: {
      get() {
        let data = this.options.hasOwnProperty("activeWritingMode")
          ? this.options.activeWritingMode
          : this.options.writingMode
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeWritingMode", false)
      }
    },
    activeTextIsThemeColor: {
      get() {
        let data = this.options.hasOwnProperty("activeTextIsThemeColor")
          ? this.options.activeTextIsThemeColor
          : this.options.textIsThemeColor
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTextIsThemeColor", false)
      }
    },
    activeFontFamily: {
      get() {
        let data = this.options.hasOwnProperty("activeFontFamily")
          ? this.options.activeFontFamily
          : this.options.fontFamily
        return data
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontFamily", false)
      }
    },
    separatorType: {
      get() {
        return this.options.separatorType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "separatorType", false)
      }
    },
    iconSrc: {
      get() {
        return this.options.iconSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconSrc", false)
      }
    },
    iconType: {
      get() {
        return this.options.iconType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconType", false)
      }
    },
    iconWidth: {
      get() {
        return this.options.iconWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconWidth", false)
      }
    },
    iconMargin: {
      get() {
        return this.options.iconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconMargin", false)
      }
    },
    iconColor: {
      get() {
        return this.options.iconColor || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColor", false)
      }
    },
    iconColorIsThemeColor: {
      get() {
        return this.options.iconColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColorIsThemeColor", false)
      }
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    lineHeightType: {
      get() {
        return this.options.lineHeightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeightType", false)
      }
    },
    letterSpacingType: {
      get() {
        return this.options.letterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacingType", false)
      }
    },
    activeLineHeightType: {
      get() {
        return this.options.activeLineHeightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeLineHeightType", false)
      }
    },
    activeLetterSpacingType: {
      get() {
        return this.options.activeLetterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeLetterSpacingType", false)
      }
    },
    hoverLineHeightType: {
      get() {
        return this.options.hoverLineHeightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverLineHeightType", false)
      }
    },
    hoverLetterSpacingType: {
      get() {
        return this.options.hoverLetterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverLetterSpacingType", false)
      }
    },
    hoverIsSameActive() {
      return this.options.hoverIsSameActive
    }
  },
  methods: {
    getFocus(event) {
      event.currentTarget.select()
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    }
  }
})
</script>

<style scoped>
.w24 {
  width: 24px;
}
.btn-inner {
  display: flex;
  align-items: center;
}
</style>
